import type { FaireProductEntity } from "../../entity_types/product";

export const casa_blanca_1: FaireProductEntity = {
  token: "casa-blanca-1",
  type: "product",
  name: "Ceramic Vase - Terracotta",
  brandName: "Casa Blanca",
  imageUrl:
    "https://cdn.faire.com/fastly/6e661e7af5192f6cc98a329451ef9dead4ac8923b9089e709f7826ddf4afb3a2.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 32,
  msrpDollars: 48,
  freeShipping: false,
  isBestseller: true,
  description: "",
  categoryTokens: [],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
